var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListItem = function SvgListItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.086 3.002c.4 0 .777.156 1.06.439l4.415 4.415c.279.279.439.666.439 1.06v10.586c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5v-15c0-.827.673-1.5 1.5-1.5h6.586Zm-.086 1H6.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-10.5h-3.5c-.827 0-1.5-.673-1.5-1.5v-3.5Zm2 11v1H9v-1h6Zm0-3v1H9v-1h6Zm-1-7.293v2.793a.5.5 0 0 0 .5.5h2.793L14 4.709Z",
    fill: "#000"
  })));
};
export default SvgListItem;